import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router';
import { ModalPortal } from 'AppSrc/core/components/portals/modal-portal';
import PropTypes from 'prop-types';
import { CrossSvg } from 'AppSrc/core/components/common/svg-icons';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';


const CompletionSubmitModalDisplay = ({
  closeModal,
  history,
  statusReasonText,
}) => {
  const backTo = () => {
    if (statusReasonText === 'Unsuccessful') {
      history.push('/');
    }
    else {
      history.push('/mycrq/fixed/My%20Fixed%20CRQs');
    }
  };


  return (
    <ModalPortal>
      <div
        className="v-f-modal-section completion-submit-modal"
      >
        <div className="v-f-modal-shadow" />
        <div className="v-f-modal-inner">
          <OptionButton
            className="cross-button"
            onClick={closeModal}
          >
            <div className="svg-container">
              <CrossSvg />
            </div>
          </OptionButton>
          <div className="completion-submit-modal-content">
            <h3 className="popup-heading">
              {
                statusReasonText === 'Unsuccessful' ? `This CRQ has been marked 'Completed - ${statusReasonText}' and additional information is required.
                Do you want to complete the ${statusReasonText} Change Review now?` : `This CRQ has been marked 'Completed -  ${statusReasonText}' and will be automatically closed in 72 hours`
              }
            </h3>
            {statusReasonText === 'Unsuccessful' && (
            <div className="form-modal-options">
              <div className="above-row">
                <button
                  type="button"
                  className="yes-button"
                  onClick={closeModal}
                >
                  {`Yes, complete the ${statusReasonText} Change Review now`}
                </button>
              </div>
              <div className="below-row">
                <button
                  type="button"
                  className="no-button"
                  onClick={backTo}
                >
                  No, add it to my Pre-closure work queue
                </button>
              </div>
            </div>
            )}
            {statusReasonText === 'Successful' && (
            <button
              className="end-button"
              type="button"
              onClick={closeModal}
            >
              <div className="end-container">
                Close
              </div>
            </button>
            )}
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

CompletionSubmitModalDisplay.propTypes = {
  closeModal: PropTypes.func,
  history: ReactRouterPropTypes.history.isRequired,
  statusReasonText: PropTypes.string,
};


const CompletionSubmitModal = withRouter(CompletionSubmitModalDisplay);


export { CompletionSubmitModal };
